import React, { Suspense } from "react";
import { StyleSheet } from "react-native";
import Loading from "@components/atoms/Loading";
import { View } from "@components/atoms/Themed";
import NavigationBar from "@components/molecules/NavigationBar";
import { goBack } from "@navigation/navigate";
import { PhoneEditScreenQuery } from "@generated/PhoneEditScreenQuery.graphql";
import PhoneEdit from "@components/templates/PhoneEdit";
import {
  usePreloadedQuery,
  useQueryLoader,
  graphql,
  PreloadedQuery,
} from "react-relay/hooks";
import _ from "lodash";

const phoneEditScreen = graphql`
  query PhoneEditScreenQuery {
    influencer {
      ...PhoneEdit
    }
  }
`;

function ScreenContent({
  queryReference,
}: {
  queryReference: PreloadedQuery<PhoneEditScreenQuery>;
}) {
  const { influencer } = usePreloadedQuery<PhoneEditScreenQuery>(
    phoneEditScreen,
    queryReference
  );
  return <PhoneEdit phoneFragment={influencer} />;
}

export default function PhoneEditScreen(): JSX.Element {
  const [queryReference, loadQuery, disposeQuery] =
    useQueryLoader<PhoneEditScreenQuery>(phoneEditScreen);
  React.useEffect(() => {
    loadQuery({});
    return () => {
      disposeQuery();
    };
  }, [loadQuery, disposeQuery]);

  return (
    <View style={styles.container}>
      <NavigationBar onBack={goBack} title="電話番号" />
      <Suspense fallback={<Loading size="large" />}>
        {!_.isNil(queryReference) && (
          <ScreenContent queryReference={queryReference} />
        )}
      </Suspense>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
